// The back office pages, grouped as the sidebar shows them. The id is also
// the URL hash (#/rides), so a refresh or a shared link opens the same page.

export interface NavItem {
  id: string;
  name: string;
  icon: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Преглед',
    items: [{ id: 'dashboard', name: 'Табло', icon: 'fas fa-chart-line' }],
  },
  {
    label: 'Операции',
    items: [
      { id: 'rides', name: 'Пътувания', icon: 'fas fa-car-side' },
      { id: 'users', name: 'Потребители', icon: 'fas fa-users' },
      { id: 'reports', name: 'Докладвани потребители', icon: 'fas fa-flag' },
      { id: 'report-analytics', name: 'Анализ на докладите', icon: 'fas fa-chart-bar' },
    ],
  },
  {
    label: 'Съдържание',
    items: [
      { id: 'festivals', name: 'Фестивали', icon: 'fas fa-calendar-alt' },
      { id: 'facebook', name: 'Facebook', icon: 'fab fa-facebook' },
      { id: 'suggestions', name: 'Предложения', icon: 'fas fa-lightbulb' },
    ],
  },
  {
    label: 'Система',
    items: [
      { id: 'maintenance', name: 'Поддръжка', icon: 'fas fa-tools' },
      { id: 'version-policy', name: 'Версии', icon: 'fas fa-mobile-alt' },
      { id: 'database-monitoring', name: 'База данни', icon: 'fas fa-database' },
      { id: 'rate-limit-monitoring', name: 'Rate limits', icon: 'fas fa-tachometer-alt' },
      { id: 'grafana-monitoring', name: 'Grafana', icon: 'fas fa-chart-area' },
    ],
  },
];

export const DEFAULT_TAB = 'dashboard';

export const findNavItem = (id: string): (NavItem & { group: string }) | undefined => {
  for (const group of NAV_GROUPS) {
    const item = group.items.find((candidate) => candidate.id === id);
    if (item) return { ...item, group: group.label };
  }
  return undefined;
};

/** The page id in a location hash such as "#/rides", or the default page. */
export const tabFromHash = (hash: string): string => {
  const id = hash.replace(/^#\/?/, '').split(/[?/]/)[0];
  return findNavItem(id) ? id : DEFAULT_TAB;
};
